import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { searchCustomers } from '../../../controllers/company/subscriptions/SubscriptionsController';

export default function UserAutocomplete({ label, onSelect, error, helperText, preSelectedValue }) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');

    // Buscar usuarios cuando el usuario escribe
    useEffect(() => {
        let active = true;

        if (inputValue === '') {
            setOptions([]);
            return undefined;
        }

        const fetchUsers = async () => {
            setLoading(true);
            // Llamamos al controlador de búsqueda
            const response = await searchCustomers(inputValue); 
            
            if (active && response.success) {
                setOptions(response.data);
            }
            setLoading(false);
        };

        // Debounce simple (esperar a que deje de escribir)
        const timer = setTimeout(() => {
            fetchUsers();
        }, 500);

        return () => {
            active = false;
            clearTimeout(timer);
        };
    }, [inputValue]);

    return (
        <Autocomplete
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.name} ${option.last_name} (${option.email})`}
            options={options}
            loading={loading}
            value={preSelectedValue} // Para control externo (ej. "Mismo que el padre")
            onChange={(event, newValue) => {
                onSelect(newValue);
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    error={error}
                    helperText={helperText}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}